import axios from "axios";

const API_URL = "https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/auth";
// const API_URL = "https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/auth";
const API_URL_TEST="http://localhost:8080/v1/api";

const signup = async (email, password, name,tutorType) => {
  const response = await axios.post(API_URL + "/signup", {
    email,
    password,
    name,
    tutorType
    
  });
  // console.log(response.data);
  // if (response.data.accessToken) {
  //     localStorage.setItem("user", JSON.stringify(response.data));
  // }
  return response.data;
};

const tutorSignup = async (email, password, name, tutor_type) => {
  const response = await axios
    // .post(API_URL + "/tutorSignup", {
    .post( "https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/auth" + "/tutorSignup", {
    // .post("https://testapis4.el.r.appspot.com/api/auth" + "/tutorSignup", {
      email,
      password,
      name,
      tutor_type
    });
  // if (response.data.accessToken) {
  //     localStorage.setItem("user", JSON.stringify(response.data));
  // }
  console.log(response.data);
  return response.data;
};

const login = async (email, password) => {
  const response = await axios.post(API_URL + "/login", {
    email,
    password,
  });
  if (response.data.accessToken) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }
  // console.log(response.data);
  return response.data;
};

const tutorLogin = async (email, password) => {
  const response = await axios.post(API_URL + "/tutorLogin", {
  // const response = await axios.post("https://testapis4.el.r.appspot.com/api/auth/tutorLogin", {
    // const response = await axios.post("https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/auth/tutorLogin", {
    email,
    password,
  });
  console.log(response.data);
  if (!JSON.parse(localStorage.getItem("tutor")) && response.data.accessToken) {
    let bankDetails = {
      ...response?.data?.saveTutor?.Bank,
      passbook: null,
    };

    let resp12 = {
      ...response?.data?.saveTutor,
      panPic: null,
      profilePic: null,
      Bank: bankDetails,
    };
    let localStObject = {
      ...response.data,
      saveTutor: resp12,
    };
    // console.log({checkSiiize :  JSON.stringify(response.data.saveTutor).length , checkSiiize12 :  response.data.accessToken.length , checkSiiize13 :  response.data.refreshToken.length})
    localStorage.setItem("tutor", JSON.stringify(localStObject));
  }
  return response.data;
};

const logout = () => {
  localStorage.removeItem("user");
};

const tutorLogout = () => {
  localStorage.removeItem("tutor");
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const authService = {
  signup,
  tutorSignup,
  login,
  tutorLogin,
  logout,
  tutorLogout,
  getCurrentUser,
};

export default authService;
